import { render, staticRenderFns } from "./VideoScreen.vue?vue&type=template&id=25f3e58e&scoped=true&"
import script from "./VideoScreen.vue?vue&type=script&lang=js&"
export * from "./VideoScreen.vue?vue&type=script&lang=js&"
import style0 from "./VideoScreen.vue?vue&type=style&index=0&id=25f3e58e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f3e58e",
  null
  
)

export default component.exports